import React from 'react'
import MetarDetailSection from './MetarDetailSection'
import MetarDetailSectionItem from './MetarDetailSectionItem'
import classnames from 'classnames'

const MetarDetailSky = props => {
  if(!props.clouds || props.clouds.length === 0) {
    return (
      <MetarDetailSection
        title={"SKY"}
      >
        <MetarDetailSectionItem
          value={"CLR"}
        />
      </MetarDetailSection>
    )
  }

  const getOutlook = level => {
    if(level.coverage === "VV") {
      return "LIFR"
    }
    if((level.coverage === "BKN" || level.coverage === "OVC") && level.altitude <= 30) {
      if(level.altitude >= 10) {
        return "MVFR"
      }
      if(level.altitude >= 5) {
        return "IFR"
      }
      return "LIFR"
    }
    return "VFR"
  }

  return (
    <MetarDetailSection
      title={"SKY"}
    >
      {props.clouds.map((rec, index) => {
        let outlook = getOutlook(rec)
        return (
          <MetarDetailSectionItem
            key={index}
            className={classnames({
              metarOutlookMVFR: outlook === 'MVFR',
              metarOutlookIFR: outlook === 'IFR',
              metarOutlookLIFR: outlook === 'LIFR'
            })}
            value={rec.altitude}
            footer={rec.coverage}
          />
        )
      })}
    </MetarDetailSection>
  )
}

export default MetarDetailSky



// WEBPACK FOOTER //
// ./src/components/MetarDetailSky.js